import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { getPnMedicationSelector } from '../../procedures/pnMedication/selectors/pnMedication.selector'
import { IPnMedicationState } from '../../procedures/pnMedication/store/pnMedication.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* addPnMedicationItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const pnMedicationState: IPnMedicationState = yield select(getPnMedicationSelector)
  const { key, time, date, pta, addToTimeline, addMedicationAdministeredData } = pnMedicationState
  if (addToTimeline) {
    const index = items.findIndex((item) => item.key === pnMedicationState.key)
    const dateTime = new Date(date || 0)
    if (time) {
      if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
      dateTime.setMinutes(+time.split(':')[1])
      dateTime.setHours(+time.split(':')[0])
    }
    const item: IItem = {
      key: key,
      grid: true,
      labelHeader: time,
      subHeader: date,
      labelHeaderFlag: pta ? 'PTA' : '',
      eventSubHeader: '',
      itemType: 'Procedures',
      event: 'Pertinent Negative Medication',
      rowActionType: TimelineConstants.SET_PN_MEDICATION_ITEM,
      defaultHref: TabConstants.PN_MEDICATION_PROCEDURE,
      date: dateTime,
    }
    addMedicationAdministeredData?.map((pnMedication) => {
      const { medicationPNNV, medication, dose, route, doseUnit } = pnMedication
      const valLabel = medicationPNNV?.name || ''
      const medLabel = medication?.name || ''
      const doseUnitLabel = doseUnit?.name || ''
      const routeLabel = route?.name || ''
      item.eventSubHeader =
        item.eventSubHeader +
        `Medication : ${medLabel}, ${valLabel}, Dose : ${dose} ${doseUnitLabel} , Via : ${routeLabel}, `
    })
    if (index !== -1) {
      items[index] = item
    } else {
      items.push(item)
    }
    yield put(setActivityLog(items))
    yield put(saveTimelineItems())
  }
}

export function* addPnMedicationItemSaga() {
  yield takeLatest([TimelineConstants.ADD_PN_MEDICATION_ITEM], performWithMutexHOG, addPnMedicationItem)
}
